import {useMemo} from "react";
import {useStores} from "../../../stores";
import {hasAgentForDatabag} from "../utils/agentDatabag";
import {useAgentMetadata} from "./useAgentMetadata";

export type ChatDatabagAvailability = {
    /** Metadata finished loading (success or error). */
    isReady: boolean;
    /** At least one agent is enabled for the active databag; false while loading. */
    isAvailable: boolean;
};

export function useChatAvailableForActiveDatabag(): ChatDatabagAvailability {
    const {bagStore} = useStores();
    const {data: agents, isPending, isError} = useAgentMetadata({
        enabled: Boolean(bagStore.bagId),
    });

    return useMemo(() => {
        const isReady = !isPending;
        if (!isReady || isError || !bagStore.bagId) {
            return {isReady, isAvailable: false};
        }
        return {
            isReady: true,
            isAvailable: hasAgentForDatabag(agents, bagStore.bagId),
        };
    }, [agents, bagStore.bagId, isPending, isError]);
}
